export const tippyDefaults = {
  animation: "fade",
  distance: 5,
  dynamicTitle: true,
  arrow: true,
  arrowType: "round",
  arrowTransform: "scale(0.7, 0.8)",
  delay: [400, 0], // [show, hide] delay
  duration: [300, 200], // [show, hide] transition duration
};
